import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BannerStrip from "@/components/BannerStrip";
import HomePage from "@/pages/HomePage";
import ListingsPage from "@/pages/ListingsPage";
import AdDetailPage from "@/pages/AdDetailPage";
import PublishAdPage from "@/pages/PublishAdPage";
import MyAdsPage from "@/pages/MyAdsPage";
import PremiumPage from "@/pages/PremiumPage";
import AdvertisersPage from "@/pages/AdvertisersPage";
import AdminStudentsPage from "@/pages/AdminStudentsPage";
import AdminWaitlistPage from "@/pages/AdminWaitlistPage";
import AdminEntryPage from "@/pages/AdminEntryPage";
import LegalNoticePage from "@/pages/LegalNoticePage";
import ComingSoonRibbon from "@/components/ComingSoonRibbon";
import { PaymentSuccessPage, PaymentCancelledPage } from "@/pages/PaymentResultPages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ComingSoonRibbon />
          <Navbar />
          <BannerStrip />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/anuncios" element={<ListingsPage />} />
              <Route path="/anuncio/:id" element={<AdDetailPage />} />
              <Route path="/publicar" element={<PublishAdPage />} />
              <Route path="/mis-anuncios" element={<MyAdsPage />} />
              <Route path="/premium" element={<PremiumPage />} />
              <Route path="/anunciantes" element={<AdvertisersPage />} />
              <Route path="/admin/estudiantes" element={<AdminStudentsPage />} />
              <Route path="/admin/lista-espera" element={<AdminWaitlistPage />} />
              <Route path="/entrada-admin" element={<AdminEntryPage />} />
              <Route path="/aviso-legal" element={<LegalNoticePage />} />
              <Route path="/pago/exito" element={<PaymentSuccessPage />} />
              <Route path="/pago/cancelado" element={<PaymentCancelledPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
